<div class="star" favoriteToggler
                  [boardId]="boardId"
                  [isFavorite]="isFavorite$ | async" 
                  [class.active]="isFavorite$ | async"></div>